import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";

export default class RatingStars extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
    
    let v = this.$root[0].dataset.rating;    
    if(v !== undefined) this.setValue(parseFloat(v)/5);
  }

  setValue(percent: number)
  {
    this.$root.find(".value").css("width", (100*percent) + "%");
  }
}